var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container",style:(_vm.containerStyle)},[_c('div',{staticStyle:{"height":"6000px"}},[_c('iframe',{staticClass:"results-frame",attrs:{"src":_vm.embedUrl,"frameborder":"0","allow":"accelerometer ; clipboard-write; encrypted-media","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }